<template>
    <section class="container-fluid mt-5 py-5">
        <div class="container mt-5 px-3">
            <!-- Header -->
            <div class="row align-items-center mb-4">
                <div class="col-md-6">
                    <h2 class="mb-1 d-flex align-items-center text-light fs-1">
                        Bancos de Semillas<span class="text-primary">.</span>
                    </h2>
                    <p class="text-muted mb-0 fs-5">
                        <i class="fas fa-seedling me-1 text-primary"></i>
                        {{ brands.length }} bancos registrados
                    </p>
                </div>
                <div class="col-md-6 d-flex justify-content-md-end mt-3 mt-md-0">
                    <router-link to="/admin/bancos/nuevo" class="btn btn-primary">
                        <i class="fas fa-plus me-2"></i>
                        Agregar banco
                    </router-link>
                </div>
            </div>

            <!-- Brands Grid -->
            <div class="row g-4">
                <div v-for="brand in brands" :key="brand.id" class="col-md-6 col-lg-4">
                    <div class="card bg-dark text-light">
                        <div class="card-body">
                            <div class="d-flex align-items-center mb-3">
                                <img :src="brand.image" :alt="brand.brand_name" class="brand-logo me-3" />
                                <div class="flex-grow-1">
                                    <h5 class="mb-1">{{ brand.brand_name }}</h5>
                                    <p class="text-muted mb-0">
                                        {{ brand.total_products || 0 }} productos
                                    </p>
                                    <span class="badge" :class="brand.is_national ? 'bg-success' : 'bg-info'">
                                        {{ brand.is_national ? 'Nacional' : 'Internacional' }}
                                    </span>
                                </div>
                            </div>
                            <p class="text-muted mb-3">{{ brand.description }}</p>
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="stock-info">
                                    <span class="badge" :class="getStockBadgeClass(brand.total_stock || 0)">
                                        {{ brand.total_stock || 0 }} unidades en stock
                                    </span>
                                </div>
                                <div class="d-flex gap-2">
                                    <button class="btn btn-outline-warning btn-sm" @click="toggleNational(brand)">
                                        <i class="fas fa-flag me-1"></i>
                                        {{ brand.is_national ? 'Hacer Internacional' : 'Hacer Nacional' }}
                                    </button>
                                    <button class="btn btn-outline-primary btn-sm" @click="editBrand(brand)">
                                        <i class="fas fa-edit me-1"></i>
                                        Editar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { getBrands, updateBrand } from '@/services/brands';

const brands = ref([]);

const getStockBadgeClass = (stock) => {
    if (stock === 0) return 'bg-danger';
    if (stock < 10) return 'bg-warning';
    return 'bg-success';
};

const editBrand = (brand) => {
    // Implementar navegación a edición
    console.log('Editar marca:', brand);
};

const toggleNational = async (brand) => {
    try {
          await updateBrand(brand.id, {
            ...brand,
            is_national: !brand.is_national
        });
        
        // Actualizar la marca en la lista local
        const index = brands.value.findIndex(b => b.id === brand.id);
        if (index !== -1) {
            brands.value[index] = { ...brands.value[index], is_national: !brand.is_national };
        }
        
        console.log(`Marca ${brand.brand_name} cambiada a ${!brand.is_national ? 'Nacional' : 'Internacional'}`);
    } catch (error) {
        console.error('Error al cambiar el tipo de marca:', error);
        // Aquí podrías mostrar un mensaje de error al usuario
    }
};

onMounted(async () => {
    try {
        const response = await getBrands();
        brands.value = response;
    } catch (error) {
        console.error('Error fetching brands:', error);
    }
});
</script>

<style scoped>
.brand-logo {
    width: 60px;
    height: 60px;
    object-fit: contain;
    border-radius: 8px;
    background-color: var(--black-color-2);
    padding: 8px;
}

.card {
    border: none;
    border-radius: 0.5rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease;
}

.card:hover {
    transform: translateY(-5px);
}

.stock-info .badge {
    font-size: 0.8rem;
    padding: 0.4em 0.8em;
}

.d-flex.gap-2 {
    gap: 0.5rem;
}

.btn-sm {
    font-size: 0.875rem;
    padding: 0.25rem 0.5rem;
}

.badge {
    font-size: 0.75rem;
    margin-top: 0.25rem;
}
</style>